export default __webpack_public_path__ + "static/media/safari-settings-steps.d11b8b80.png";